<template>
  <div>
    <div class="cardContainer" v-if="listType=='Card'">
      <person-card v-for="(person, index) in persons" :key="index" :person="person"></person-card>
    </div>

    <!-- Used on search page -->
    <div v-if="listType=='Table' && persons.length > 0 && topX>-1" class="flexrow">
      <div class="result-table">
        <div class="result-header right" v-if="topX <= persons.length">{{ $t('persons.found') }} ({{ topX }} {{ $t('persons.outOf') }} {{ persons.length }})</div>
        <div class="result-header right" v-if="topX > persons.length">{{ $t('persons.found') }}</div>
        <div v-for="(person, index) in topPersons" :key="index" :person="person" class="result-line">
          <router-link :to="/persons/ + person.personId">{{person.name}} ({{person.latestRating}})</router-link>
          <div class="pushright">KNSB nr: {{person.federationNumber}}</div>
        </div>
      </div>
      <img :src="playerIcon" alt="players" class="logo-display-small" /> 
    </div>


    <!-- Used on club page -->
    <div v-if="listType=='Table' && persons.length > 0" class="flexrow">
      <div class="result-table">
        <div class="result-header"><h2>spelers ({{ seniors.length }})</h2></div>
        <div v-for="(person, index) in seniors" :key="index" :person="person" class="result-line">
          <div class="index-column">{{index+1}}</div>
          <router-link :to="/persons/ + person.personId">{{person.name}} ({{person.latestRating}})</router-link>
          <div class="pushright">KNSB nr: {{person.federationNumber}}</div>
        </div>

        <div class="result-header"><h2>jeugdspelers ({{ juniors.length }})</h2></div>
        <div v-for="(person, index) in juniors" :key="index" :person="person" class="result-line">
          <div class="index-column">{{index+1}}</div>
          <router-link :to="/persons/ + person.personId">{{person.name}} ({{person.latestRating}})</router-link>
          <div class="pushright">KNSB nr: {{person.federationNumber}}</div>
        </div>
      </div>

      <img :src="playerIcon" alt="players" class="logo-display-small" /> 
    </div>

<!--  details nog overnemen voor detail lijst.
    <section>
      <div class="result-header">leden ({{memberCount}})</div> 
      <table class="result-table">
        <tr class="result-row" v-for="(person, index) in people" :key="person.personId" :person="person">
          <td>{{index+1}}</td>
          <td>{{person.federationNumber}}</td>
          <td>{{person.name}}</td>
          <td class="result-cell-last">{{person.latestRating}}</td>
        </tr>
      </table>
      <img :src="playerIcon" alt="players" class="logo-display-small" />
    </section>
  -->



    <div v-if="listType=='Select' && persons.length > 0">
      <div v-if="optionSelectAll">
        <div class="selectAllContainer">
          <div><input type="checkbox" @change="toggleSelectAll"></div>
          <div> {{selectAllText}}</div>
        </div>
      </div>
      <div class="personContainer">
        <div v-for="(person, index) in persons" :key="index" :person="person" class="person">
          <input class="checkbox" type="checkbox" :id="index" :value="person.personId" v-model="selectedPersonIDs">  
          <div class="number"> {{person.name}}<br/>{{person.federationNumber}}</div>
        </div>
      </div>  
    </div>

    

    <div v-if="listType=='SelectOne' && persons.length > 0">
      <div class="personContainer">
        <div v-for="(person, index) in persons" 
          :id="'panel'+index"
          :key="index" 
          :person="person" 
          @click="selectPanel(index, person.personId)"
          class="selectOnePerson">
          <div class="number"> {{person.name}}<br/>{{person.federationNumber}}
            <div v-if="person.federationCode==0"><br/><i>manually added</i></div>
          </div>        
        </div>
      </div>  
    </div>

    <div v-if="listType=='SelectFederationOriginal' && persons.length > 0">
      <div class="personContainer">
        <template v-for="(person, index) in persons">
          <div v-if="person.federationCode === 1"
              :key="person.personId"
              :id="'panel'+index"
              @click="selectPanel(index, person.personId)"
              class="selectOnePerson">
            <div class="number"> {{person.name}}<br/>{{person.federationNumber}}
              <div v-if="person.federationCode==0"><br/><i>manually added</i></div>
            </div>        
          </div>
        </template>
      </div>  
    </div>

</div>
</template>


<script>



import PersonCard from "@/components/players/PersonCard";

export default {
  name: 'PersonsList',
  components: {PersonCard},
  props: {
    persons: Array,
    listType: String,
    optionSelectAll: Boolean,
    topX: -1
  },
  data: function() {
    return {
        panelID: -1,
        selectedPersonIDs: [],
        selectAllText: "select all",
        playerIcon: require('../../assets/img/CA_Player_black.png'),
    }
  },
  emits: ['personListChanged'],
  computed: {
    topPersons: function() {
      console.log("topX: " + this.topX)
      if (this.persons.length != 0) {
        return this.persons.slice(0, this.topX);
      } else 
        return [];
    },
    seniors() {
      return this.persons.filter(p => p.category === 'Senior');
    },
    juniors() {
      return this.persons.filter(p => p.category === 'Junior');
    }
  },
  watch: {
    persons: function(val, oldVal) {
      if (oldVal != val) {
        this.selectedPersonIDs = [];
        this.panelID = -1;
      }
    },
    selectedPersonIDs: function(val, oldVal) {
      if (oldVal != val)
        this.$emit("personListChanged", this.selectedPersonIDs);
    }
  },
  methods: {
    toggleSelectAll: function() {
      if (this.selectAllText == "select all") {
      // toggle selectedPersonID's  
        var selected = [];
        this.persons.forEach(function (person) {
            selected.push(person.personId);
        });
        this.selectedPersonIDs = selected;
      // toggle the button
        this.selectAllText = "select none";
      } else {
      // toggle selectedPersonID's  
        this.selectedPersonIDs = [];
      // toggle the button
        this.selectAllText = "select all";
      }
    },

    // selectPanel is only applicable with listType SelectOne.
    // this function makes the panel looking 'selected" and 
    // updates the selectedPersonID array to the selected personId.
    selectPanel: function(id, personId) {
      if (this.panelID == id) {
        // select/unselect current panel
        var panel = document.getElementById('panel' + id);
        if (panel.classList.contains("selected")) {
          panel.classList.remove("selected");
        } else {
          panel.classList.add("selected");
        
        }
      } else {
        // unselect old panel, select new panel
        if (this.panelID != -1) {
          var oldPanel = document.getElementById(this.panelID);
          oldPanel.classList.remove("selected");
        }
        var newPanel = document.getElementById('panel' + id);
        newPanel.classList.add("selected");
        this.panelID = 'panel' + id;
        this.selectedPersonIDs = [personId];
      }
    }

  }
}
</script>

<style scoped>

.index-column{
  width: 34px;
}

.floatRight {
  float: right;
}

.link:hover {
  font-weight: bold;
}

.personContainer {
  max-width: 98vw;
  display: grid;
  grid-gap: 1vw;
  overflow-y: auto;
  overflow-x: hidden;
  height: 35vh;
}

.selectAllContainer {
  display: flex;
  flex-direction: row;
}

.selectAllContainer input[type="checkbox"] {
 margin-top: 2px;
 margin-right: 4px;
}

input[type="checkbox"] {
 margin: 0;
 margin-top: 6px;
 padding: 0;
 border-radius: 2px;
 width: 18px;
 height: 18px;
}

.person {
  display: flex;
  flex-direction: row;
}

.selectOnePerson {
  display: flex;
  flex-direction: row;
  background: #111;
  border-radius: 2px;
  cursor: pointer;
  padding-left: 4px;
  color: #8fabd6 ; /*  #8fabd6 ; #5681c2; */
}

.selectOnePerson:hover {
  color: #5681c2;
  transition: border .3s linear, color .3s linear;
}

.selected {
  color: #5681c2;
  border: 1px solid #5681c2;
  transition: border .3s linear, color .3s linear;
}

.number {
  padding: 4px;
}

/* mobile */
@media screen and (max-width: 600px) {
  .personContainer {
    grid-template-columns: repeat(1, 1fr);
  }
  .cardContainer {
    grid-template-columns: repeat(1, 1fr);
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .personContainer {
    grid-template-columns: repeat(3, 1fr);
  }
  .cardContainer {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  .personContainer {
    grid-template-columns: repeat(3, 1fr);
  }

  .cardContainer {
    grid-template-columns: repeat(3, 1fr);
  }
}

</style>

